const initialState = {
  data: [],
  singleSites: {
    sites: [],
    timeframe: 24,
    loadingSingleSites: null,
  }
};

const all = (state = initialState, action) => {
  switch (action.type) {
    case "LOAD_SITES_BACKGROUND_START":
      return { ...state, loading: true };
    case "LOAD_SITES_BACKGROUND_SUCCESS":
      return {
        ...state,
        loading: false,
        meta: action.meta,
        // Add to the current data
        data: {
          ...state.data,
          // cacheSubKey is enterprise_id
          [action.cacheSubKey]: action.data
        }
      };
    case "LOAD_SITES_BACKGROUND_RESTORE":
      // TODO: how can we prevent a disk restore if we know there has been no change to the data?
      //  solution is to use memoize in the saga
      // if (_.get(action, "unchanged")) {
      //   return { ...state, loading: false };

      // }
      return {
        ...state,
        loading: false,
        meta: action.meta,
        // Add to the current data
        data: {
          ...state.data,
          // cacheSubKey is enterprise_id
          [action.cacheSubKey]: action.data
        }
      };

    // SINGLE SITES LIST
    case "LOAD_SINGLE_SITES_LIST_START":
      return {
        ...state,
        singleSites: {
          ...state.singleSites,
          loadingSingleSites: true,
        }
      };

    case "LOAD_SINGLE_SITES_LIST_SUCCESS":
      return {
        ...state,
        singleSites: {
          ...state.singleSites,
          sites: (action.data && action.data.sites)
            ? action.data.sites.map((site) => {
                return {
                  ...site,
                  id: site.sudo_site_id,
                  name: site.site_name,
                }
              })
            : [],
          loadingSingleSites: false,
        }
      };

    case "LOAD_SINGLE_SITES_LIST_FAILED":
      return {
        ...state,
        singleSites: {
          ...state.singleSites,
          loadingSingleSites: false,
        }
      };

    case "LOAD_SINGLE_SITES_LIST_CANCEL":
      return {
        ...state,
        singleSites: {
          ...state.singleSites,
          loadingSingleSites: false,
        }
      };

    // SINGLE SITE LIST LIVE REFRESH
    case "LOAD_SINGLE_SITES_LIST_REFRESH_START":
      return {
        ...state,
        singleSites: {
          ...state.singleSites,
          loadingSingleSites: true,
        }
      };

    case "LOAD_SINGLE_SITES_LIST_REFRESH_SUCCESS":
      return {
        ...state,
        singleSites: {
          ...state.singleSites,
          sites: (action.data && action.data.sites)
            ? action.data.sites.map((site) => {
                return {
                  ...site,
                  id: site.sudo_site_id,
                  name: site.site_name,
                }
              })
            : [],
          loadingSingleSites: false,
        }
      };

    case "LOAD_SINGLE_SITES_LIST_REFRESH_FAILED":
      return {
        ...state,
        singleSites: {
          ...state.singleSites,
          loadingSingleSites: false,
        }
      };

    case "LOAD_SINGLE_SITES_LIST_REFRESH_CANCEL":
      return {
        ...state,
        singleSites: {
          ...state.singleSites,
          loadingSingleSites: false,
        }
      };

    case "CHANGE_SINGLE_SITES_TIMEFRAME":
      return {
        ...state,
        singleSites: {
          ...state.singleSites,
          timeframe: action.timeframe,
        }
      }

    case "LOGOUT_REQUEST":
      // Reset to initial state when user logs out
      return initialState;
    default:
      return state;
  }
};

export default all;